import { PayloadAction } from '@reduxjs/toolkit';
import { HttpServiceResponse } from '@/services/HttpService/types';
import { GetSelectedPlaceDetailsPayload } from '../store/types/GetSelectedPlaceDetailsPayload';
import { GetSelectedPlaceDetailsResponse, GetSuggestedPlacesListResponse } from './types';
import { call, put, takeLatest } from 'redux-saga/effects';
import HttpService from '@/services/HttpService/HttpService';
import { transformSuggestedPlacesListResponse } from './utils/transformSuggestedPlacesListResponse';
import { GoogleApiBaseUrls } from '../../enums/GoogleApiBaseUrls';
import {
  getSelectedPlaceDetails,
  getSuggestedPlacesList,
  setSuggestedPlacesListLoadingStatus,
  updateSelectedPlaceDetails,
  updateSuggestedPlacesList,
} from '../store/googlePlacesApiSlice';

const apiKey = import.meta.env.VITE_GOOGLE_API_KEY;

function* getSuggestedPlacesListSaga({ payload }: PayloadAction<any>) {
  try {
    yield put(setSuggestedPlacesListLoadingStatus(true));

    const { data }: HttpServiceResponse<GetSuggestedPlacesListResponse> = yield call(
      HttpService.post,
      `${GoogleApiBaseUrls.PLACES}/places:autocomplete?key=${apiKey}`,
      {
        input: payload,
        languageCode: 'en',
      },
      { baseURL: '' },
    );

    const transformedData = transformSuggestedPlacesListResponse(data);
    yield put(updateSuggestedPlacesList(transformedData));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setSuggestedPlacesListLoadingStatus(false));
  }
}

function* getSelectedPlaceDetailsSaga({
  payload: { placeId, uniqPrefix },
}: PayloadAction<GetSelectedPlaceDetailsPayload>) {
  try {
    const { data }: HttpServiceResponse<GetSelectedPlaceDetailsResponse> = yield call(
      HttpService.get,
      `${GoogleApiBaseUrls.PLACES}/places/${placeId}?key=${apiKey}`,
      { languageCode: 'en' },
      {
        baseURL: '',
        headers: {
          'X-Goog-FieldMask':
            'formattedAddress,addressComponents.shortText,addressComponents.longText,addressComponents.types',
        },
      },
    );
    yield put(updateSelectedPlaceDetails({ data, uniqPrefix }));
  } catch (error) {
    console.error(error);
  }
}

export function* googlePlacesApiWatcher() {
  yield takeLatest(getSuggestedPlacesList.type, getSuggestedPlacesListSaga);
  yield takeLatest(getSelectedPlaceDetails.type, getSelectedPlaceDetailsSaga);
}
